import { ModalBody, ModalFooter, useStyletron } from "@mezo-org/mezo-clay"

import { StepperModalButton } from "../StepperModal"
import { ComponentStepProps } from "../StepperModal/StepperModal"

import BridgeSummaryList from "./BridgeSummaryList"

export default function BridgeReviewStep({
  onClickContinue,
}: ComponentStepProps) {
  const [css, theme] = useStyletron()

  // TODO: Temporary solution
  const summary = [
    {
      label: "Via",
      endEnhancer: "Native Bridge",
    },
    {
      label: "Transfer Time",
      endEnhancer: "~3 mins",
    },
    {
      label: "Network fees",
      endEnhancer: "0.0001066 ETH ($2.89)",
    },
    {
      label: "Service fees",
      endEnhancer: "0 fees",
    },
  ]

  return (
    <>
      <ModalBody
        className={css({
          height: "100%",
          display: "flex",
          flexDirection: "column",
          gap: theme.sizing.scale900,
        })}
      >
        <BridgeSummaryList list={summary} />
      </ModalBody>
      <ModalFooter>
        <StepperModalButton onClick={onClickContinue}>
          Confirm
        </StepperModalButton>
      </ModalFooter>
    </>
  )
}
